import React from 'react'
import {
  Dialog,
  DialogAdornment,
  DialogWindow,
  DialogHeader,
  DialogBody,
  space,
} from '@ticketswap/solar'
import styled from '@emotion/styled'
import { createMarkup } from '../../utils'
import { CloseAlt } from '@ticketswap/comets'

// TODO: Export this from Solar at some point, re-using the
// styles of the existing textual elements.
const MarkdownOutput = styled.div`
  p + *,
  li + li {
    margin-top: ${space[16]};
  }

  ul {
    padding-left: ${space[16]};
    list-style: initial;
  }
`

function TraderInformationDialog({ t, children, ...props }) {
  return (
    <Dialog {...props}>
      {({ hide, getToggleProps, getWindowProps }) => (
        <>
          {children({ getToggleProps, hide })}
          <DialogWindow {...getWindowProps()}>
            <DialogHeader>
              {t('common:traderInformationDialog.title')}
              <DialogAdornment right>
                <button onClick={hide}>
                  <CloseAlt size={24} />
                </button>
              </DialogAdornment>
            </DialogHeader>
            <DialogBody>
              <MarkdownOutput
                dangerouslySetInnerHTML={createMarkup(t('common:traderInformationDialog.text'))}
              />
            </DialogBody>
          </DialogWindow>
        </>
      )}
    </Dialog>
  )
}

export default TraderInformationDialog
